import React from 'react';
import { SpotShape } from '../../types';
import { generateShapeId } from '../../utils/generateShapeId';
import { createNodeShape } from '../../utils/shapeFactory';
import { useSpotLabelIterator } from './hooks/useSpotLabelIterator';
import { ShapeProvider } from './shapes/ShapeContext/ShapeProvider';
import { SpotShapeComponent } from './shapes/SpotShape/SpotShape';
export const SpotGhostItem = React.forwardRef<
  React.ElementRef<typeof SpotShapeComponent>
>((_, ref) => {
  const customShape = createNodeShape({ x: 0, y: 0 }) as SpotShape;
  const spotLabel = useSpotLabelIterator();
  customShape.label = spotLabel.next(false).join('');

  const ghostId = React.useMemo(() => generateShapeId('spot'), []);

  return (
    <ShapeProvider
      shape={customShape}
      isSelected={false}
      onSelect={() => null}
      onUpdate={() => null}
    >
      <SpotShapeComponent
        x={100}
        y={100}
        ref={ref}
        draggable={false}
        id={ghostId}
        onClick={() => null}
        onContextMenu={() => null}
        onMouseEnter={() => null}
        onMouseLeave={() => null}
        onTransformEnd={() => null}
        onTap={() => null}
        onDragEnd={() => null}
        onDragMove={() => null}
        onDragStart={() => null}
        rotation={0}
      />
    </ShapeProvider>
  );
});
